import { useState, useEffect } from "react";
import useEffectOnce from "src/hooks/useEffectOnce";
import { ThemeProvider } from "styled-components";
import LoadingWrapper from 'src/components/Loading/LoadingWrapper';
import useTheme from "./useCustomTheme";
const colors = {
    primary: '#0066CC',        // primario
    letraPrimaria1: '#FFCC00', // letra Primaria 1 
    letraPrimaria2: '#ffffff',  // letra Primaria 2 
    primarySemiDark: "#005CB8",
    primaryLight: '#E5F3FF',
    primaryDark: '#003366',
    primaryDark2: '#003478',
    secondary: '#FFCC00',    // segundario
    secondaryLight: '#FFDC52',
    secondaryDark: '#FFCC00',
    ternario: '#0066CC',
    letraTernario1: '#0066CC',
    letraTernario2: '#9999',
    colorStepper: '#FFCC00',
    bg1: '#EFF3F5',
    textColorButton: '#fff', // letra primaria 1
    labelInputColor: '#768DA3',
    textColor1: ' #000',
    textColor2: ' #314960',
    textColor3: ' #FAFAFA',
    textError: '#FF0000',
    success: '#31C259',
    labelLanding: ' #fff',
    letraSegundaria1: '#003478', // letra segundaria 1 
    letraSegundaria2: '#0066CC', // letra segundaria 2
}
export const themeDefault = {
    colors: { primary: colors.primary, ...colors },
    color: {...colors},
    mainFont: 'Helvetica Neue',
    fontSizes: {
        small: '0.8rem',
        medium: '1.07rem',
        large: '1.7rem',
        small2: '0.7rem',
        medium2: '0.9rem',
        large2: '1.1rem',
    },
    buttons: {
        primary: {
            color: colors.textColorButton,
            backgroundColor: colors.primary,
            border: `2px solid ${colors.primary}`,
        },
        secondary: {
            color: colors.primary,
            backgroundColor: colors.textColorButton,
            border: `2px solid ${colors.primary}`,
        },
        disabled: {

        }
    },
    label: {
        color: colors.labelInputColor,
        fontWeight: 'bold',
    },
    checked: {
        borderColor: colors.labelInputColor,
    }

};

const Theme = ({ dark = false, children }) => {
    const [theme, setTheme] = useState(themeDefault)

    const { ligthTheme, darkTheme, getTheme, custonTheme, isLoading } = useTheme(themeDefault);
    console.log("isLoading", isLoading, custonTheme, darkTheme)
    useEffect(() => {
        if (!isLoading) {
            if (ligthTheme && !dark) {
                setTheme(ligthTheme)
            } else if (dark && darkTheme) {
                setTheme(darkTheme)
            }
        }
    }, [])
    useEffect(() => {
        setTheme(custonTheme)
    }, [custonTheme])


    return isLoading ? <LoadingWrapper loading={isLoading} secundario="Verificando información"></LoadingWrapper> : <ThemeProvider theme={theme}>{children}</ThemeProvider>
}

export default Theme;